<template>
  <div class="physioAsset">
    <div class="physioAsset-card" v-for="(item,index) in physioAssetList" :key="index">
      <div class="physioAsset-card-title">
        <div class="physioAsset-card-title-text">{{item.physioName}}</div>
        <div class="physioAsset-card-title-remain">余{{item.remainNum}}次</div>
      </div>
      <div class="physioAsset-card-item">
        <div class="physioAsset-card-item-label">近30天共执行：</div>
        <div class="physioAsset-card-item-value">{{item.useOfMonth || 0}}次</div>
      </div>
      <div class="physioAsset-card-item">
        <div class="physioAsset-card-item-label">上次执行时间：</div>
        <div class="physioAsset-card-item-value">{{item.usePhysioDate || '-'}}</div>
      </div>
      <div class="physioAsset-card-item">
        <div class="physioAsset-card-item-label">开单医馆：</div>
        <div class="physioAsset-card-item-value">{{item.deptName || '-'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props:{
    physioAssetList:Array,
  },
  data(){
    return{

    }
  }
}
</script>

<style lang="less" scoped>
.physioAsset {
  flex: 1;
  background: #FAFAFA;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .physioAsset-card {
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #E0E0E0;
    padding: 8px;
    box-sizing: border-box;

    .physioAsset-card-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 4px;
      .physioAsset-card-title-text {
        flex: 1;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .physioAsset-card-title-remain {
        font-weight: 400;
        font-size: 14px;
        color: #29C01B;
        margin-right: 12px;
        flex-shrink: 0;
      }
    }

    .physioAsset-card-item {
      height: 21px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #667182;
    }
  }
}
</style>